export const horizontalNavBarDataHooks = {
  root: 'horizontal-nav-bar',
  title: 'horizontal-nav-bar-title',
  sideContent: 'horizontal-nav-bar-side-content',
  skeleton: 'horizontal-nav-bar-skeleton',
};
